import { render, staticRenderFns } from "./authBox.vue?vue&type=template&id=72d1f26f&scoped=true&"
import script from "./authBox.vue?vue&type=script&lang=js&"
export * from "./authBox.vue?vue&type=script&lang=js&"
import style0 from "./authBox.vue?vue&type=style&index=0&id=72d1f26f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1f26f",
  null
  
)

export default component.exports